module.exports = __webpack_public_path__ + "static/img/item-l_j_apple.1485fd9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/item-l_j_apple.png
// module id = gpv/
// module chunks = 1